import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery'


class OutsourcingISIT extends Component {
    componentDidMount(){


        function resetMenu(){
            $("#home a").removeClass("active");

            $("#sluzby-a-produkty-link").removeClass("active");
            $("#prodej-instalace-li").removeClass("active");
            $("#lokalni-li").removeClass("active");
            $("#outsourcing-li").removeClass("active");
            $("#audit-is-li").removeClass("active");
            $("#webhosting-li").removeClass("active");
            $("#webdesign-li").removeClass("active");
            $("#cenik-praci-li").removeClass("active");

            $("#o-firme-li a").removeClass("active");
            $("#reference-li a").removeClass("active");
            $("#kontakty-li a").removeClass("active");
            $("#podpora-li a").removeClass("active");
        }

        resetMenu();

        $("#outsourcing-li").addClass("active");
        $("#basic-nav-dropdown").addClass("active");


    }
  render() {
    return (
<div>


        <div className="container content fade-in two" id="outsourcing-it">
            <h1>Kompletní outsourcing IS/IT:</h1>
            <span>
            Tato služba pro klienta znamená přenesení různě velké části odpovědnosti za provoz, údržbu, vývoj a stabilitu informačního systému na poskytovatele outsourcingu. Klient se tak může plně věnovat předmětu své činnosti a za péči o informační systém je zodpovědná externí firma. Firma Ricom Zdeněk Richtr je poskytovalem širokého rozmezí služeb outsourcingu. Můžeme pro vás navrhnout a vybudovat informační systém, o který jsme schopni kvalifikovaně pečovat a který dokážeme následně rozvíjet přesně podle vašich rostoucích potřeb. Rozsah naší péče se řídí individuálními potřebami klienta. Firma Ricom Zdeněk Richtr je schopna dodat celý informační systém - tedy hardware i software, zprovoznit ho a zajistit veškerou údržbu, rozvoj a servis. Samozřejmostí je i podpora a školení uživatelů a poskytnutí telefonické hot-line podpory.
<br/><br/>
          <h2>Co pro vás znamená outsourcing od nás:</h2>
           <li>Převezmeme odpovědnost za provoz vašeho informačního systému.</li>
           <li>Budou vám přesně podle vašich potřeb k dispozici odborníci dobře seznámení s vaším informačním systémem - ať už ho sami navrhli a vytvořili nebo ne.</li>
           <li>Vývoj vašeho informačního systému bude  plynulý s čímž souvisí i redukce nárazových investic.</li>
<br/>
            Více o outsourcingu naleznete <Link to="/sluzby-a-produkty/co-je-to-outsourcing">zde</Link>.
            </span>

        </div>


</div>
    );
  }
}

export default OutsourcingISIT;



// WEBPACK FOOTER //
// ./src/sluzby-a-produkty/OutsourcingISIT.js